const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    name: {
      type: 'string',
      title: 'نام',
    },
  },
});

export default schema;
